var map = {
	"./af/apple.png": 195336,
	"./af/google.png": 535484,
	"./ar/apple.png": 31233,
	"./ar/google.png": 434723,
	"./az/apple.png": 721439,
	"./az/google.png": 310373,
	"./bg/apple.png": 877548,
	"./bg/google.png": 742182,
	"./bn/apple.png": 799624,
	"./bn/google.png": 123189,
	"./bs/apple.png": 239182,
	"./bs/google.png": 336914,
	"./cs/apple.png": 665497,
	"./cs/google.png": 666171,
	"./da/apple.png": 675626,
	"./da/google.png": 874411,
	"./de/apple.png": 242515,
	"./de/google.png": 353985,
	"./el/apple.png": 557152,
	"./el/google.png": 864999,
	"./en-AU/apple.png": 947058,
	"./en-AU/google.png": 610197,
	"./en-GB/apple.png": 263525,
	"./en-GB/google.png": 420616,
	"./en/apple.png": 504768,
	"./en/google.png": 126679,
	"./es-AR/apple.png": 714218,
	"./es-AR/google.png": 983358,
	"./es-ES/apple.png": 310183,
	"./es-ES/google.png": 102018,
	"./es/apple.png": 393714,
	"./es/google.png": 545944,
	"./et/apple.png": 319716,
	"./et/google.png": 540059,
	"./eu/apple.png": 263226,
	"./eu/google.png": 65429,
	"./fi/apple.png": 141446,
	"./fi/google.png": 45229,
	"./fr-CA/apple.png": 962340,
	"./fr-CA/google.png": 439683,
	"./fr/apple.png": 559443,
	"./fr/google.png": 740467,
	"./gl/apple.png": 203286,
	"./gl/google.png": 259289,
	"./he/apple.png": 298295,
	"./he/google.png": 160284,
	"./hi/apple.png": 267076,
	"./hi/google.png": 878830,
	"./hr/apple.png": 365254,
	"./hr/google.png": 539941,
	"./hu/apple.png": 118228,
	"./hu/google.png": 490230,
	"./id/apple.png": 437786,
	"./id/google.png": 357158,
	"./it/apple.png": 911570,
	"./it/google.png": 249438,
	"./ja/apple.png": 99619,
	"./ja/google.png": 306970,
	"./ka/apple.png": 549766,
	"./ka/google.png": 41190,
	"./kk/apple.png": 331469,
	"./kk/google.png": 874163,
	"./km/apple.png": 769522,
	"./km/google.png": 372817,
	"./ko/apple.png": 245804,
	"./ko/google.png": 133529,
	"./lt/apple.png": 811099,
	"./lt/google.png": 671300,
	"./lv/apple.png": 239097,
	"./lv/google.png": 467805,
	"./mk/apple.png": 439225,
	"./mk/google.png": 690434,
	"./ms/apple.png": 158194,
	"./ms/google.png": 420452,
	"./nb/apple.png": 212140,
	"./nb/google.png": 788729,
	"./nl/apple.png": 41944,
	"./nl/google.png": 594519,
	"./pl/apple.png": 474512,
	"./pl/google.png": 362294,
	"./pt-PT/apple.png": 210564,
	"./pt-PT/google.png": 989664,
	"./pt/google.png": 153407,
	"./ro/apple.png": 565032,
	"./ro/google.png": 637872,
	"./ru/apple.png": 119392,
	"./ru/google.png": 261935,
	"./sk/apple.png": 690128,
	"./sk/google.png": 438878,
	"./sl/apple.png": 708166,
	"./sl/google.png": 118769,
	"./sr/apple.png": 925693,
	"./sr/google.png": 737328,
	"./sv/apple.png": 293806,
	"./sv/google.png": 701830,
	"./ta/apple.png": 541594,
	"./ta/google.png": 313218,
	"./te/apple.png": 198741,
	"./te/google.png": 324780,
	"./th/apple.png": 661373,
	"./th/google.png": 423410,
	"./tl/apple.png": 483007,
	"./tl/google.png": 660138,
	"./tr/apple.png": 608576,
	"./tr/google.png": 152269,
	"./uk/apple.png": 991591,
	"./uk/google.png": 883107,
	"./vi/apple.png": 310969,
	"./vi/google.png": 453657,
	"./zh-Hans/apple.png": 519963,
	"./zh-Hans/google.png": 219017,
	"./zh-Hant/apple.png": 453642,
	"./zh-Hant/google.png": 625491
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16547;